import { get } from 'lodash';
import {
  textFilter,
  numberFilter,
  Comparator,
  selectFilter,
} from 'react-bootstrap-table2-filter';

import {
  getUserPreference,
  setUserPreference,
} from '../../../helpers/user-preferences';

const FilterStyles = {
  fontSize: '14px',
  textAlign: 'center',
  display: 'inline',
  width: '100%',
};

export function textFilterIncludes(
  placeholderText,
  fields,
  rowModifier = undefined,
  caseInsensitive = true
) {
  return textFilter({
    placeholder: 'Filter ' + placeholderText,
    style: FilterStyles,
    id: 'name',
    onFilter: (value, rows) => {
      const filteredRows = rows.filter((row) => {
        if (typeof fields === 'string') fields = [fields];
        let searchTerms = fields.map((field) => get(row, field, ''));
        if (caseInsensitive) {
          searchTerms = searchTerms.map((term) =>
            term ? term.toLowerCase() : ''
          );
          value = value.toLowerCase();
        }
        let result = false;
        searchTerms.forEach((term) => {
          if (term.includes(value)) result = true;
        });
        return result;
      });
      return !rowModifier ? filteredRows : rowModifier(filteredRows);
    },
  });
}

export function textFilterIncludesPreference(
  placeholderText,
  fields,
  rowModifier = undefined,
  caseInsensitive = true,
  localStorageKey = undefined
) {
  return textFilter({
    placeholder: 'Filter ' + placeholderText,
    style: FilterStyles,
    id: 'name',
    onFilter: (value, rows) => {
      if (localStorageKey) setUserPreference(localStorageKey, value);
      const filteredRows = rows.filter((row) => {
        if (typeof fields === 'string') fields = [fields];
        let searchTerms = fields.map((field) => get(row, field, ''));
        if (caseInsensitive) {
          searchTerms = searchTerms.map((term) =>
            term ? term.toLowerCase() : ''
          );
          value = value.toLowerCase();
        }
        let result = false;
        searchTerms.forEach((term) => {
          if (term.includes(value)) result = true;
        });
        return result;
      });
      return !rowModifier ? filteredRows : rowModifier(filteredRows);
    },
  });
}

export function textFilterArray(placeholderText, field) {
  return textFilter({
    placeholder: 'Filter ' + placeholderText,
    style: FilterStyles,

    onFilter: (selected, rows) => {
      return rows.filter((row) =>
        get(row, field, []).some((item) => item.name.includes(selected))
      );
    },
  });
}

export function numberFilterStyle(placeholderText) {
  return numberFilter({
    style: FilterStyles,
    placeholder: 'Filter ' + placeholderText,
    comparators: [Comparator.EQ, Comparator.GE, Comparator.LE],
    withoutEmptyComparatorOption: true,
  });
}

export function selectFiltering(
  placeholderText,
  selectOptions,
  key,
  withoutEmptyOption = false,
  rowModifier = undefined,
  localStorageKey = undefined,
  caseInsensitive = false
) {
  return selectFilter({
    placeholder: 'Filter ' + placeholderText,
    options: selectOptions,
    style: FilterStyles,
    withoutEmptyOption: withoutEmptyOption,
    defaultValue: localStorageKey ? getUserPreference(localStorageKey) : 0,
    onFilter: (selected, rows) => {
      if (localStorageKey) setUserPreference(localStorageKey, selected);
      let selection = selectOptions[parseInt(selected)];
      if (caseInsensitive) selection = selection.toLowerCase();
      const filteredRows =
        // without empty opt, treat 0 selection as unfiltered
        // this workaround allows restyling on un-filter
        withoutEmptyOption && parseInt(selected) === 0
          ? rows
          : rows.filter((row) => {
              // If the key is a string, look for the match otherwise search within each element for a match
              const result = get(row, key);
              return (
                !!result &&
                (typeof result === 'string'
                  ? result === selection
                  : result.some((item) => selection.includes(item)))
              );
            });
      return !rowModifier ? filteredRows : rowModifier(filteredRows);
    },
  });
}

export function roleSelect(placeholderText, roles, orgId) {
  return selectFilter({
    placeholder: 'Filter ' + placeholderText,
    options: roles,
    style: FilterStyles,
    onFilter: (selected, rows) => {
      return rows.filter((roleRow) =>
        roleRow.organization_roles.some(
          (item) =>
            roles[selected].toLowerCase() === item.role &&
            parseInt(orgId) === item.organization_id
        )
      );
    },
  });
}

export function locationFilter(placeholderText, USAStates, locality) {
  return textFilter({
    placeholder: 'Filter ' + placeholderText,
    style: FilterStyles,
    onFilter: (selected, rows) => {
      const stateSearch = isNaN(parseInt(selected, 10));
      const term = stateSearch
        ? selected.toLowerCase()
        : USAStates[parseInt(selected)].toLowerCase();
      return rows.filter((row) =>
        row.address.address_components.some((address) => {
          const termResult = address.long_name.toLowerCase().includes(term);
          return stateSearch
            ? termResult && address.types.includes(locality)
            : termResult;
        })
      );
    },
  });
}
